import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  searchInput: {},
  searchIcon: {
    paddingLeft: 8,
    width: 'unset',
  },
}));
